import { render, staticRenderFns } from "./FileBoxVertical.vue?vue&type=template&id=7add9f57&scoped=true&"
import script from "./FileBoxVertical.vue?vue&type=script&lang=js&"
export * from "./FileBoxVertical.vue?vue&type=script&lang=js&"
import style0 from "./FileBoxVertical.vue?vue&type=style&index=0&id=7add9f57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add9f57",
  null
  
)

export default component.exports